// src/components/Analytics.js - FIXED VERSION
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const Analytics = () => {
  const location = useLocation();
  const hasSentInitialView = useRef(false);

  // Use the correct API URL - FIXED: Use tailorapi.mentoran.in, not tailoringapp.onrender.com
  const API_BASE_URL = 'https://tailorapi.mentoran.in';

  useEffect(() => {
    console.log('📍 Analytics: Location changed to', location.pathname);

    // Temporarily remove admin route skipping for testing
    // if (location.pathname.startsWith('/admin')) {
    //   console.log('🔒 Analytics: Skipping admin route');
    //   return;
    // }

    const trackPageLoad = async () => {
      if (!hasSentInitialView.current) {
        await trackPageView('initial_load');
        hasSentInitialView.current = true;
      } else {
        await trackPageView('route_change');
      }
    };

    // Add slight delay to ensure page is fully loaded
    const timer = setTimeout(trackPageLoad, 100);
    return () => clearTimeout(timer);
  }, [location]);

  const trackPageView = async (trigger) => {
    try {
      const sessionId = getSessionId();
      
      const payload = {
        path: location.pathname,
        trigger: trigger,
        timestamp: Date.now(),
        sessionId: sessionId,
        referrer: document.referrer || 'direct',
        screen: `${window.screen.width}x${window.screen.height}`,
        language: navigator.language,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        url: window.location.href,
        userAgent: navigator.userAgent
      };

      console.log('📊 Analytics: Sending page view to:', `${API_BASE_URL}/api/analytics/pageview`);

      const response = await fetch(`${API_BASE_URL}/api/analytics/pageview`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit'
      });

      console.log('📡 Response status:', response.status);
      console.log('📡 Response headers:', Object.fromEntries(response.headers.entries()));

      // Check if response has content before trying to parse JSON
      const responseText = await response.text();
      console.log('📡 Response text:', responseText);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${responseText}`);
      }

      // Only parse as JSON if there's content
      let result;
      if (responseText && responseText.trim() !== '') {
        result = JSON.parse(responseText);
        console.log('✅ Analytics: Page view tracked successfully', result);
      } else {
        console.log('✅ Analytics: Page view tracked (empty response)');
        result = { status: 'tracked', message: 'Empty response' };
      }

      return result;

    } catch (error) {
      console.error('❌ Analytics: Tracking failed:', error);
      
      // More specific error handling
      if (error.name === 'SyntaxError' && error.message.includes('JSON')) {
        console.error('📝 JSON Parse Error: Backend returned non-JSON response');
        console.error('💡 This might be a CORS preflight issue or backend error');
      } else if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        console.error('🌐 Network Error: Cannot connect to analytics server');
      }
    }
  };

  const getSessionId = () => {
    try {
      let sessionId = sessionStorage.getItem('analytics_session_id');
      
      if (!sessionId) {
        sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        sessionStorage.setItem('analytics_session_id', sessionId);
        console.log('🆕 Analytics: New session started', sessionId);
      }
      
      return sessionId;
    } catch (error) {
      return `fallback_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
  };

  return null;
};

export default Analytics;